import React, { MouseEvent } from 'react';
import { StyledCardLink } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { setHash } from '../../../../../shared/router/hash/hashHistory';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { BookingDate } from '../../../booking/BookingDate';
import { BookingStatus } from '../../../booking/BookingStatus';
import { createBookingDateTimeString } from '../../helpers/createBookingDateTimeString';
import { getBookingDetailsHash } from '../../details';
import {
	StyledMyBookingCard,
	StyledMyBookingCardRow,
	StyledMyBookingCardTitleRow,
	StyledMyBookingCardTopRow,
} from './StyledMyBookingCard';

interface IMyBookingCardProps {
	booking: IBooking;
}

export const MyBookingCard = ({ booking }: IMyBookingCardProps) => {
	const { t } = useTranslation();

	const hash = getBookingDetailsHash(booking.reference);

	const handleClick = (e: MouseEvent) => {
		e.preventDefault();
		setHash(hash);
	};

	return (
		<StyledMyBookingCard onClick={handleClick}>
			<StyledMyBookingCardTopRow>
				<div>{booking.reference}</div>
				<BookingStatus status={booking.status} />
			</StyledMyBookingCardTopRow>
			<StyledMyBookingCardTitleRow>
				{booking.parkingProduct.name}
			</StyledMyBookingCardTitleRow>
			<StyledMyBookingCardRow>
				<BookingDate
					date={createBookingDateTimeString(
						booking.parkingProductsQuote.startDate,
						booking.parkingProductsQuote.startTime,
					)}
					selectedTime={booking.parkingProductsQuote.startTime}
				/>
			</StyledMyBookingCardRow>
			<hr />
			<StyledMyBookingCardRow>
				<BookingDate
					date={createBookingDateTimeString(
						booking.parkingProductsQuote.endDate,
						booking.parkingProductsQuote.endTime,
					)}
					selectedTime={booking.parkingProductsQuote.endTime}
				/>
			</StyledMyBookingCardRow>
			<hr />
			<StyledMyBookingCardRow>
				<StyledCardLink href={hash}>
					{t('parking_landing_your_bookings_view_details')}
				</StyledCardLink>
			</StyledMyBookingCardRow>
		</StyledMyBookingCard>
	);
};
